const PERIOD24HOURS = '00:00-23:59';

export const dayOfWeekMap: { [index: string]: string } = {
  monday: 'Segunda',
  tuesday: 'Terça',
  thursday: 'Quarta',
  wednesday: 'Quinta',
  friday: 'Sexta',
  saturday: 'Sábado',
  sunday: 'Domingo',
  holiday: 'Feriado'
};

export const WorkHour = (props: { weekDay: string; period: string }) => {
  function formatTimePeriod(period: string) {
    if (period === PERIOD24HOURS) return '24h';
    return period.replace('-', ' às ');
  }

  if (dayOfWeekMap[props.weekDay] && props.period)
    return (
      <p id="description">
        {`${dayOfWeekMap[props.weekDay] || props.weekDay}: `}
        <span>{formatTimePeriod(props.period)}</span>
      </p>
    );
  return null;
};
